import styled from "styled-components"
import Colors from "../../theme/colors"

const Input = styled.input`
  font-family: Avenir Regular;
  min-width: 410px;
  position: relative;
  width: 100%;
  height: 44px;
  margin-right: 8px;
  background-color: ${Colors.white};
  border: 1px solid ${Colors.white}
  border-radius: 10px;
  padding-left: 24px;
  font-size: 16px;
  color: ${Colors.primaryBlack}
  line-height: 1.3;
  &::placeholder {
    font-size: 16px;
    color: ${Colors.primaryGrey}
    line-height: 1.3;
  }
  &:focus {
    padding-left: 25px;
    font-size: 16px;
    &::placeholder {
      opacity: 0;
    }
  }
`

export default Input



// WEBPACK FOOTER //
// ./src/components/input/input.component.tsx